import TicketTemplatePreviewModalController from '../controllers/modals/preview-modal';
import templateUrl from '../views/modals/preview-modal.tpl.html';

export default function ticketTemplatePreviewModalCreator($injector, ticketTemplateId, templateModel) {
    return $injector.get('$uibModal')
        .open({
            controller: TicketTemplatePreviewModalController,
            controllerAs: 'vm',
            templateUrl,
            backdrop: 'static',
            size: 'lg',
            resolve: {
                templateId: () => ticketTemplateId,
                templateModel: () => templateModel
            }
        })
}



// WEBPACK FOOTER //
// ./src/app/modules/tickets/templates/helpers/ticket-template-preview-modal-creator.js